(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-kids"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Brand switch: slides the pill, then opens the selected page */
  if (!customElements.get('brand-switch')) {
    class BrandSwitch extends HTMLElement {
      connectedCallback() {
        this.initialSide = this.dataset.active;
        this.links = Array.from(this.querySelectorAll('a[data-side]'));
        this.onClick = this.onClick.bind(this);
        this.onPageShow = this.onPageShow.bind(this);

        this.links.forEach((link) => link.addEventListener('click', this.onClick));
        window.addEventListener('pageshow', this.onPageShow);
      }

      disconnectedCallback() {
        this.links.forEach((link) => link.removeEventListener('click', this.onClick));
        window.removeEventListener('pageshow', this.onPageShow);
        window.clearTimeout(this.navTimer);
      }

      /* Restore the correct side when the user comes back with the browser Back button */
      onPageShow(event) {
        if (event.persisted) this.setActive(this.initialSide);
      }

      setActive(side) {
        this.dataset.active = side;
        this.links.forEach((link) => {
          const isActive = link.dataset.side === side;
          link.classList.toggle('is-active', isActive);
          if (isActive) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }

      onClick(event) {
        /* Let new-tab / modified clicks work normally */
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

        const link = event.currentTarget;
        const target = new URL(link.href, window.location.origin);

        /* Already on that exact page: do nothing */
        if (link.dataset.side === this.dataset.active && target.pathname === window.location.pathname) {
          event.preventDefault();
          return;
        }

        event.preventDefault();
        this.setActive(link.dataset.side);

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.clearTimeout(this.navTimer);
        this.navTimer = window.setTimeout(() => {
          window.location.href = target.href;
        }, reduceMotion ? 0 : 280);
      }
    }

    customElements.define('brand-switch', BrandSwitch);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener(
        'change',
        this.setHeaderHeight.bind(this)
      );

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);

      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );
    }

    createObserver() {
      let observer = new IntersectionObserver(
        (entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        }
      );

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) {
        return;
      }

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(
          this.hide.bind(this)
        );

      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(
            this.reveal.bind(this)
          );
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(
            this.hide.bind(this)
          );
        }

      } else if (
        scrollTop <= this.headerBounds.top
      ) {
        this.header.classList.remove(
          'scrolled-past-header'
        );

        requestAnimationFrame(
          this.reset.bind(this)
        );
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll('header-menu');

      this.disclosures.forEach(
        (disclosure) => disclosure.close()
      );
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal ||
        this.header.querySelector('details-modal');

      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define(
    'sticky-header',
    StickyHeader
  );

  /* Brand switch */

  if (!customElements.get('brand-switch')) {
    class BrandSwitch extends HTMLElement {
      connectedCallback() {
        this.initialSide = this.dataset.active;

        this.links = Array.from(
          this.querySelectorAll('a[data-side]')
        );

        this.onClick = this.onClick.bind(this);
        this.onPageShow = this.onPageShow.bind(this);

        this.links.forEach((link) => {
          link.addEventListener(
            'click',
            this.onClick
          );
        });

        window.addEventListener(
          'pageshow',
          this.onPageShow
        );
      }

      disconnectedCallback() {
        this.links.forEach((link) => {
          link.removeEventListener(
            'click',
            this.onClick
          );
        });

        window.removeEventListener(
          'pageshow',
          this.onPageShow
        );

        window.clearTimeout(this.navTimer);
      }

      onPageShow(event) {
        if (event.persisted) {
          this.setActive(this.initialSide);
        }
      }

      setActive(side) {
        this.dataset.active = side;

        this.links.forEach((link) => {
          const isActive =
            link.dataset.side === side;

          link.classList.toggle(
            'is-active',
            isActive
          );

          if (isActive) {
            link.setAttribute(
              'aria-current',
              'true'
            );
          } else {
            link.removeAttribute(
              'aria-current'
            );
          }
        });
      }

      onClick(event) {
        if (
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          event.button !== 0
        ) {
          return;
        }

        const link = event.currentTarget;

        const target = new URL(
          link.href,
          window.location.origin
        );

        if (
          link.dataset.side === this.dataset.active &&
          target.pathname === window.location.pathname
        ) {
          event.preventDefault();
          return;
        }

        event.preventDefault();

        this.setActive(
          link.dataset.side
        );

        const reduceMotion =
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;

        window.clearTimeout(
          this.navTimer
        );

        this.navTimer = window.setTimeout(
          () => {
            window.location.href =
              target.href;
          },
          reduceMotion ? 0 : 280
        );
      }
    }

    customElements.define(
      'brand-switch',
      BrandSwitch
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-sliders"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.stack-features-container').forEach(function (container) {
    const cards = container.querySelectorAll('.stack-features-card');
    const cardHeight = parseInt(container.dataset.cardHeight, 10) || 320;

    cards.forEach(function (card) {
      card.style.height = cardHeight + 'px';
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
